export default __webpack_public_path__ + "static/media/img_qa_setting.93cb39cf.jpg";